import React from 'react';
import StockContext from '../../../contexts/StocksContext'
import StatusContext from '../../../contexts/StatusContext'
import Stack from '@mui/material/Stack'
import { ArrowForwardIconGray } from '../customicons/ArrowForwardIconGray';
import { ConfirmDialog } from '../alertdialog/ConfirmDialog';
import { useState } from "react";

import './stockstemplates.css'

export const Analyze = () => {

  const [openConfirmDialog, setOpenCoonfirmDialog] = useState(false);
  const [dialogtext, setDialogText] = useState('')

  const closeConfirmDialogBox = () => {
  setOpenCoonfirmDialog(false)
}

const confirmYes = () => {
  setOpenCoonfirmDialog(false)
}

const handleAnalyze = () => {
  if (stockSymbols.length === 0)
  {
      setDialogText('There are no symbols. Please add more.')
      setOpenCoonfirmDialog(true)
      return
  }

   if (prompts.length === 0)
      {
        setDialogText('There is no strategy. Please select one.')
        setOpenCoonfirmDialog(true)
        return
    }

  onAnalyze()
}

let {
    changeLanguageEnglish,
  } = React.useContext(StatusContext);
  
  let {
    prompts,
    stockSymbols, 
    onAnalyze
  } = React.useContext(StockContext);

  return (
     <div className="controls">
      <button
        type="button"
        onClick={handleAnalyze}
        className="add-btn"
      >
        <Stack  style={{textAlign:'center'}} direction="row" spacing={1}>
          <label style={{fontSize:'18px'}}>{changeLanguageEnglish("stocks", "analyze")}</label>
          <ArrowForwardIconGray />
          </Stack>
      </button>
       <ConfirmDialog alertYes={confirmYes} openDialog = {openConfirmDialog} closeDialog = {closeConfirmDialogBox} prompt={dialogtext}/>
    </div>
  );
};
